const InventoryPage = () => {
    return <div className="p-5">Ini adalah halaman Inventory</div>;
  };
  
  export default InventoryPage;
  